export default server => ({

    store(url, name, file, onUploadProgress) {
        let formData = new FormData();

        formData.append(name, file);
        return server.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    },
    async remove(url, id) {
        let {data} = await server.delete(`${url}/${id}`);
        return data;
    }
});